export default __webpack_public_path__ + "static/media/img-11.18341244.jpg";